import { Navigate, useLocation } from "react-router-dom"
import { isB2BUser, isRetailUser, hasSidebarPermission } from "../constants/permissions"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
}) => {
  const location = useLocation()
  const authUser = localStorage.getItem("authUser")

  if (isAuthProtected && !authUser) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Role-based route restrictions
  if (authUser) {
    try {
      const user = JSON.parse(authUser)
      const role = (user.role || "").toLowerCase().trim()
      const userId = user.id
      const currentPath = location.pathname
      const permissions = user.permissions || {}

      // B2B users can ONLY access /quote
      if (isB2BUser(permissions)) {
        if (currentPath !== "/quote") {
          return <Navigate to="/quote" replace />
        }
      }

      // Retail users can ONLY access /quote
      if (isRetailUser(permissions)) {
        if (currentPath !== "/quote") {
          return <Navigate to="/quote" replace />
        }
      }

      // Store users can ONLY access /store/:storeId
      if (role === "store") {
        const allowedPath = `/store/${userId}`
        if (!currentPath.startsWith("/store/")) {
          return <Navigate to={allowedPath} replace />
        }
        if (currentPath !== allowedPath) {
          return <Navigate to={allowedPath} replace />
        }
      }

      // Driver users can ONLY access /driver/:driverId
      if (role === "driver") {
        const allowedPath = `/driver/${userId}`
        if (!currentPath.startsWith("/driver/")) {
          return <Navigate to={allowedPath} replace />
        }
        if (currentPath !== allowedPath) {
          return <Navigate to={allowedPath} replace />
        }
      }

      // Legacy: Quote users can ONLY access /quote
      if (role === "quote" && !isB2BUser(permissions) && !isRetailUser(permissions)) {
        if (currentPath !== "/quote") {
          return <Navigate to="/quote" replace />
        }
      }
    } catch (e) {
      // Invalid authUser JSON, redirect to login
      localStorage.removeItem("authUser")
      return <Navigate to="/login" replace />
    }
  }

  return (
    <Layout>
      <Component />
    </Layout>
  )
}

export default Authmiddleware
